import { useEffect, useState } from "react";

const supported = () => typeof IntersectionObserver !== "undefined";

// True once the element has scrolled ABOVE the top of the viewport (used to
// show the sticky offer bar after the first block has been read).
export function usePassed(ref) {
  const [passed, setPassed] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !supported()) return undefined;
    const io = new IntersectionObserver(([e]) =>
      setPassed(!e.isIntersecting && e.boundingClientRect.top < 0)
    );
    io.observe(el);
    return () => io.disconnect();
  }, [ref]);
  return passed;
}

// True while any `threshold` of the element is on screen.
export function useVisible(ref, threshold = 0.1) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || !supported()) return undefined;
    const io = new IntersectionObserver(([e]) => setVisible(e.isIntersecting), { threshold });
    io.observe(el);
    return () => io.disconnect();
  }, [ref, threshold]);
  return visible;
}
